import { HeadCellSortState } from '@foradevelopment/fora-ui';

import { InvoicesTableSortId } from '../../../common/types';

export type InvoicesTableSortState = typeof defaultInvoicesListSortState;
export type InvoicesTableSortIdKeys = keyof typeof defaultInvoicesListSortState;

export const defaultInvoicesListSortState = {
  [InvoicesTableSortId.InvoiceOcrNumber]: HeadCellSortState.None,
  [InvoicesTableSortId.InvoiceStatus]: HeadCellSortState.None,
  [InvoicesTableSortId.InvoiceType]: HeadCellSortState.None,
  [InvoicesTableSortId.InvoiceDate]: HeadCellSortState.None,
  [InvoicesTableSortId.InvoiceDueDate]: HeadCellSortState.None,
  [InvoicesTableSortId.InvoiceAmount]: HeadCellSortState.None,
};
